import CryptoJS from 'crypto-js';
const secretKey =
  process.env.QRCODE_DECODE_SECRET_KEY ||
  process.env.GATSBY_QRCODE_DECODE_SECRET_KEY ||
  '';

export const encryptQuery = (query: string) => {
  const ciphertext = CryptoJS.AES.encrypt(query, secretKey).toString();
  return encodeURIComponent(ciphertext);
};

export const decryptQuery = (encryptedQuery: string) => {
  try {
    const decodedQuery = decodeURIComponent(encryptedQuery);

    const bytes = CryptoJS.AES.decrypt(decodedQuery, secretKey);
    const decryptedQuery = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedQuery;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error decoding or decrypting the query:', error);
    return '';
  }
};
